import DynamicContentsList from './DynamicContentsList';

export default DynamicContentsList;
